import React from "react";
import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./AppLayout";
import BackAdmin from "./BackAdmin";
import EditData from "./EditData";
import GalleryArtWork from "./pages/GalleryArtWork";
import EditImageDesign from "./pages/EditImageDesign";
import FrontendDeveloper from "./pages/FrontendDeveloper";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";

const Router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
  },
  {
    path: "/gallery",
    element: <GalleryArtWork />,
  },
  {
    path: "/frontend-developer",
    element: <FrontendDeveloper />,
  },
  {
    path: "/back-login",
    element: <LoginPage />,
  },
  {
    path: "/back-admin",
    element: <BackAdmin />,
  },
  {
    path: "/back-admin/edit-data",
    element: <EditData />,
  },
  {
    path: "/back-admin/edit-image-design",
    element: <EditImageDesign />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default Router;
